import React, { useState, useEffect } from 'react'
import AnimatedNumber from 'animated-number-react'
import { useMediaQuery } from 'react-responsive'
import { Text, View, useStyles } from '@ion-ui/core'
import { Styles } from './styles'

const CounterCard = ({ number, title, amount }) => {
  const styles = useStyles(Styles)
  const match = number.replace(/\D/g, '')
  const [value] = useState(match)
  let formatSplit = null
  if (match) {
    formatSplit = number.split(match)
  }

  const formatValue = value => {
    const formattedValues = formatSplit.join(Number(value).toFixed(0))
    const parsedWithCommas = formattedValues.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return parsedWithCommas
  }

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' })

  const [scroll, setScroll] = useState(false)

  const scrollViewPx = isMobile ? 1575 : 1660

  useEffect(() => {
    if (window) {
      window.addEventListener('scroll', () => {
        if (document && document.documentElement && document.documentElement.scrollTop > scrollViewPx) {
          setScroll(true)
        }
      })
    }
  }, [scrollViewPx])

  return (
    <View css={styles.mainContainer}>
      <View css={styles.animatedContainer}>
        {scroll
          ? <AnimatedNumber
            className={'AnimatedNumber'}
            duration={1500}
            value={value}
            formatValue={formatValue}
          />
          : null
        }
        <Text variant='h5' css={styles.amountStyle}>
          {amount.includes('mil MDP')
            ? 'mil MDP'
            : amount.includes('MDP')
              ? 'MDP'
              : amount.includes('mil')
                ? 'mil'
                : ''
          }
        </Text>
      </View>
      <Text variant='h6' css={styles.styleTitle}>{title}</Text>
    </View>
  )
}

export default CounterCard
